import React from 'react';
import { faGasPump } from '@fortawesome/pro-regular-svg-icons/faGasPump';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function GasPumpRegularIcon(props) {
  return <FontAwesomeIcon icon={faGasPump} {...props} />;
}
